const guiColors = {
    'color-scheme': 'light',

    'ui-primary': 'rgba(255, 255, 255, 0.55)',
    'ui-secondary': 'rgba(255, 255, 255, 0.42)',
    'ui-tertiary': 'rgba(255, 255, 255, 0.65)',

    'ui-modal-overlay': 'rgba(99, 102, 241, 0.18)',
    'ui-modal-background': 'rgba(255, 255, 255, 0.95)',
    'ui-modal-foreground': '#1a1a2e',
    'ui-modal-header-background': 'var(--looks-secondary)',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#ffffff',
    'ui-white-dim': 'rgba(255, 255, 255, 0.75)',
    'ui-white-transparent': 'rgba(255, 255, 255, 0.25)',
    'ui-transparent': 'rgba(255, 255, 255, 0)',

    'ui-black-transparent': 'rgba(26, 26, 46, 0.08)',

    'text-primary': '#1a1a2e',
    'text-primary-transparent': 'rgba(74, 74, 106, 0.85)',

    'motion-primary': '#6366f1',
    'motion-primary-transparent': 'rgba(99, 102, 241, 0.9)',
    'motion-tertiary': '#4f46e5',

    'looks-secondary': '#764ba2',
    'looks-transparent': 'rgba(99, 102, 241, 0.35)',
    'looks-light-transparent': 'rgba(99, 102, 241, 0.12)',
    'looks-secondary-dark': '#667eea',

    'red-primary': '#ff416c',
    'red-tertiary': '#e6395a',

    'sound-primary': '#a855f7',
    'sound-tertiary': '#9333ea',

    'control-primary': '#f7971e',

    'data-primary': '#ff8c1a',

    'pen-primary': '#10b981',
    'pen-transparent': 'rgba(16, 185, 129, 0.25)',
    'pen-tertiary': '#059669',

    'error-primary': '#ff416c',
    'error-light': '#ff6b8a',
    'error-transparent': 'rgba(255, 65, 108, 0.25)',

    'extensions-primary': '#6366f1',
    'extensions-tertiary': '#4f46e5',
    'extensions-transparent': 'rgba(99, 102, 241, 0.35)',
    'extensions-light': 'rgba(99, 102, 241, 0.12)',

    'drop-highlight': '#818cf8',

    'menu-bar-background': 'rgba(255, 255, 255, 0.72)',
    'menu-bar-background-image': 'none',
    'menu-bar-foreground': '#1a1a2e',

    'assets-background': '#f2f5f9',

    'input-background': 'rgba(255, 255, 255, 0.85)',

    'popover-background': '#ffffff',

    'shadow': 'rgba(0, 0, 0, 0.07)',

    'badge-background': '#e3eafc',
    'badge-border': 'rgba(99, 102, 241, 0.25)',

    'fullscreen-background': '#f2f5f9',
    'fullscreen-accent': '#e8edf5',

    'page-background': '#f2f5f9',
    'page-foreground': '#1a1a2e',

    'project-title-inactive': 'var(--ui-white-transparent)',
    'project-title-hover': 'rgba(255, 255, 255, 0.7)',

    'link-color': '#6366f1',

    'filter-icon-black': 'none',
    'filter-icon-gray': 'grayscale(100%)',
    'filter-icon-white': 'none',

    'paint-ui-pane-border': 'var(--ui-black-transparent)',
    'paint-text-primary': 'var(--text-primary)',
    'paint-form-border': 'var(--ui-black-transparent)',
    'paint-looks-secondary': 'var(--looks-secondary)',
    'paint-looks-transparent': 'var(--looks-transparent)',
    'paint-input-background': 'var(--input-background)',
    'paint-popover-background': 'var(--popover-background)',
    'paint-filter-icon-gray': 'none'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
